import { createPortal } from 'react-dom';

import { ToastContainer } from 'react-toastify';

const ModalToastContainer = () =>
  createPortal(<ToastContainer position="bottom-right" />, document.body);

export default ModalToastContainer;
